export const ReviewScheduleType = {
    SEND_IMMEDIATELY: 'SendImmediately',
    SCHEDULE_FOR_LATER: 'ScheduleForLater',
} as const;

export type ReviewScheduleType = (typeof ReviewScheduleType)[keyof typeof ReviewScheduleType];
